/*
 * Copyright (c) 2020.
 * Simon
 */

export default function tokenSaveToLocalStorage(json) {
    localStorage.setItem('token_type', JSON.stringify(json['token_type']));
    localStorage.setItem('expires_in', JSON.stringify(json['expires_in']));
    localStorage.setItem('access_token', JSON.stringify(json['access_token']));
    localStorage.setItem('refresh_token', JSON.stringify(json['refresh_token']));
}
